/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationCountriesCountryidLangsQueryResponse,
  GetApiV1LocationCountriesCountryidLangsPathParams,
  GetApiV1LocationCountriesCountryidLangs401,
  GetApiV1LocationCountriesCountryidLangs500,
} from "../../types/locationCountryLangController/GetApiV1LocationCountriesCountryidLangs.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationCountriesCountryidLangs } from "../../clients/locationCountryLangController/getApiV1LocationCountriesCountryidLangs.ts";

export const getApiV1LocationCountriesCountryidLangsQueryKey = (
  countryId: GetApiV1LocationCountriesCountryidLangsPathParams["countryId"],
) =>
  [
    {
      url: "/api/v1/location/countries/:countryId/langs",
      params: { countryId: countryId },
    },
  ] as const;

export type GetApiV1LocationCountriesCountryidLangsQueryKey = ReturnType<
  typeof getApiV1LocationCountriesCountryidLangsQueryKey
>;

export function getApiV1LocationCountriesCountryidLangsQueryOptions(
  countryId: GetApiV1LocationCountriesCountryidLangsPathParams["countryId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1LocationCountriesCountryidLangsQueryKey(countryId);
  return queryOptions<
    GetApiV1LocationCountriesCountryidLangsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesCountryidLangs401
      | GetApiV1LocationCountriesCountryidLangs500
    >,
    GetApiV1LocationCountriesCountryidLangsQueryResponse,
    typeof queryKey
  >({
    enabled: !!countryId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationCountriesCountryidLangs(countryId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as traduções (idiomas) cadastradas para o país informado. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs}
 */
export function useGetApiV1LocationCountriesCountryidLangs<
  TData = GetApiV1LocationCountriesCountryidLangsQueryResponse,
  TQueryData = GetApiV1LocationCountriesCountryidLangsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1LocationCountriesCountryidLangsQueryKey,
>(
  countryId: GetApiV1LocationCountriesCountryidLangsPathParams["countryId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationCountriesCountryidLangsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1LocationCountriesCountryidLangs401
          | GetApiV1LocationCountriesCountryidLangs500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1LocationCountriesCountryidLangsQueryKey(countryId);

  const query = useQuery(
    {
      ...getApiV1LocationCountriesCountryidLangsQueryOptions(countryId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1LocationCountriesCountryidLangs401
      | GetApiV1LocationCountriesCountryidLangs500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
